<template>
		<div id="pageRoot">
			<p class="textBase" id="text01">
				Busca el título del cuento y señálalo.
			</p>

			<label class="toggleButtonContainer pageElement" id="toggle01" style="width: 360px;">Venancio vuela bajito
				<input type="radio" name="nombreLibro" value="1" @change="toggleSelect(1)" ref="t1">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle02" style="width: 360px;">Valentín salta bajito
				<input type="radio" name="nombreLibro" value="2" @change="toggleSelect(2)" ref="t2">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle03" style="width: 360px;">Venancio vuela bonito
				<input type="radio" name="nombreLibro" value="3" @change="toggleSelect(3)" ref="t3">
				<span class="toggleButton"></span>
			</label>
			<label class="toggleButtonContainer pageElement" id="toggle04" style="width: 360px;">Valentín vuela bajito
				<input type="radio" name="nombreLibro" value="4" @change="toggleSelect(4)" ref="t4">
				<span class="toggleButton"></span>
			</label>

			<img class="pageElement bouncingItem" id="doggie" src="/pages/img/sordo/svgPage70Dog.svg">
			<img class="pageElement slideItem" id="cloudy" src="/pages/img/sordo/svgPage70Cloud.svg" style="filter: brightness(120%);">

			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
			<div class="pageSVG">
				<img src="/pages/img/sordo/svgPage77Background.svg" class="pageElement" style=" width: 100%; height: auto;">
			</div>
			<span class="footer-page footer-write"></span>
			<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
		</div>
</template>
<style scoped>

#text01{
position: absolute;
width: 540px;
height: 35px;
left: 88px;
top: 63px;
font-size: 24px;
line-height: 33px;
}

#toggle01{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 188.86px;

z-index: 3;
}
#toggle02{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 262.95px;
z-index: 3;

}
#toggle03{/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 336.09px;
z-index: 3;
}
#toggle04{
/* Ellipse 3 */

position: absolute;
width: 42.89px;
height: 42.89px;
left: 304px;
top: 410.18px;
z-index: 3;
}
#doggie
{
position: absolute;
width: 208.2px;
height: 119.96px;
left: 432.37px;
top: 588px;

transform: rotate(16.65deg);
}
#cloudy
{
position: absolute;
width: 213px;
height: 117.35px;
left: 758px;
top: 63px;
}
</style>

<script>
export default {
computed: {
    dbId(){
        return `${this.$parent.pageID()}-nombreLibro`
    },          
},
methods:{
    toggleSelect(option){
		this.$db.options.put({
                    id: this.dbId,
                    option: option
                }).catch(function(error){
                    console.log("error saving option" + error);
                });
		console.log(this.dbId);
		console.log(option);
	}
},
async created() {
	var value = await this.$db.options.get({
	id: this.dbId,
	}).catch(function(error){
	console.log("error getting option" + error);
	});
	if (value === undefined) return;
	console.log("loaded value");
	console.log(value);

	if (value.option === 1){
	this.$refs.t1.checked = true;
	}
	else if (value.option === 2)
	{
	this.$refs.t2.checked = true;
	}
	else if (value.option === 3) {
	this.$refs.t3.checked = true;
	}
	else {
	this.$refs.t4.checked = true;
	}
	},
}
</script>